<template>
    <b-card no-body class="location-view">
        <slot name="section"></slot>
        <b-card-body class="location-popup inner-page">
            <b-tabs align="center" card class="p-0" content-class="tabs" v-model="tabIdx">
                <b-tab :title="$translate('address')" :title-link-class="'fw-bold'" active>
                    <b-card-body class="p-0">
                        <b-overlay :show="internalLoading" rounded="sm">
                            <b-form class="form-sample p-0 filter-form" @submit.stop.prevent="onSubmit">
                                <b-row>
                                    <b-col v-for="(d_item, i) in dataItems" :key="i + 'data'" :class="{
                'd-flex align-items-end pb-2 gap-2':
                    d_item.type === 'check' &&
                    !sectionOnly,
                dd:
                    d_item.field === 'state_name' ||
                    d_item.field === 'country_code',
            }" class="mt-3" :md="d_item.field === 'name' &&
                customer_id
                ? 12
                : 6
                " cols="12">
                                        <div class="form-check" v-if="d_item.type === 'check' &&
                !sectionOnly
                ">
                                            <label class="form-check-label me-3">
                                                <input type="checkbox" class="form-check-input top-2" :id="'input-' + d_item.field
                " :disabled="viewable || disabled || (d_item.field == 'is_warehouse' && !!customer_id)
                " v-model="model[d_item.field]
                " :name="'input-' + d_item.field
                " :value="1" :unchecked-value="0" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <label :for="'input-' + d_item.field" :class="{
                'mb-2': d_item.type === 'check',
                'mb-3': d_item.type !== 'check',
            }"><strong>
                                                {{
                d_item.field ==
                    'country_code'
                    ? $translate('country')
                    : $translate(
                        d_item.field
                    )
            }}
                                                <span v-if="d_item.required" class="red">*</span>
                                            </strong>
                                        </label>
                                        <b-form-input v-if="d_item.type === 'text'" :id="'input-' + d_item.field"
                                            class="form-control lh-base" v-model="model[d_item.field]"
                                            :required="d_item.required" :disabled="disabled" v-custom-validation="d_item.required
                ? $textRequired()
                : ''
                " :readonly="!!d_item.readonly" trim></b-form-input>
                                        <b-col v-if="d_item.field === 'country_code'
                ">
              
                                            <b-form-select class="form-control" value-field="value"
                                                :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                                :disabled="disabled" v-custom-validation="d_item.required
                ? $selectRequired()
                : ''
                " :required="d_item.required" :options="getData(d_item.field)">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
                $translate(
                    'select_country'
                )
            }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>

                                        <b-form-select class="form-control" v-if="d_item.field === 'state_name'"
                                            value-field="text" :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]" :required="d_item.required"
                                            :options="getData(d_item.field)" :disabled="disabled" v-custom-validation="d_item.required
                ? $selectRequired()
                : ''
                ">
                                            <template #first>
                                                <b-form-select-option :value="null" selected>
                                                    {{
                $translate(
                    'select_state'
                )
            }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-form-row class="mt-4 mb-2">
                                    <b-col class="d-flex justify-content-center gap-2">
                                        <b-button id="create-location-btn" v-if="!hideControls &&
                hasPermissionCreate &&
                !model.id
                " type="submit" variant="info" class="btn-fw" :disabled="!!internalLoading">{{ createLabel
                                            }}</b-button>
                                        <b-button id="update-location-btn" v-if="!hideControls &&
                hasPermissionUpdate &&
                model.id
                " type="submit" variant="info" class="btn-fw" :disabled="!!internalLoading">{{ updateLabel
                                            }}</b-button>

                                        <b-button id="delete-location-btn" v-if="!hideControls &&
                this.model.id &&
                hasPermissionDelete
                " @click="deleteLocation()" size="fw" variant="delete-button">
                                            {{ $translate('delete_location') }}
                                        </b-button>
                                        <b-button id="cancel-location-btn" v-if="!hideControls" variant="info" class="btn-fw"
                                            :disabled="!!internalLoading" @click="$router.go(-1)">{{
                $translate('cancel')
            }}</b-button>
                                        <slot v-bind:default="model"></slot>
                                    </b-col>
                                </b-form-row>
                            </b-form>
                        </b-overlay>
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('map')" :title-link-class="'fw-bold'">
                    <b-card-body class="my-4 p-0">
                        <location-picker v-if="tabIdx == 1" :title="$translate('map_location')" :location="mapLocation"
                            @set-location="coords => setCoordinates(coords)" @get-location="locationdata => getLocation(locationdata)
                " />
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('sections')" :title-link-class="'fw-bold'" v-if="!sectionOnly && !!model.id">
                    <b-card-body class="p-0">
                        <b-form class="form-sample p-0" inline>
                            <b-row class="my-3" no-gutters>
                                <b-col cols="4">
                                    <b-form-input :placeholder="$translate('section_name')
                " id="inline-form-input-name" class="mt-2 mt-md-0 lh-base" v-model="sectionModel.name"></b-form-input>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-input id="inline-form-input-description"
                                        :placeholder="$translate('description')" class="mt-2 mt-md-0 lh-base"
                                        v-model="sectionModel.description"></b-form-input>
                                </b-col>

                                <b-col cols="2">
                                    <div class="d-flex gap-2">
                                        <b-button id="save-section-btn" class="mt-2 mt-md-0 ms-2" variant="blue-icon"
                                            @click="saveSection(sectionModel)">
                                            <img src="@/assets/images/icon/gradient-add.svg" />
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form>

                        <b-table :fields="sectionFields" responsive striped hover :items="sections">
                            <template #cell(name)="row">
                                <b-form-input :id="row.index + 'name'" v-model="row.item.name"></b-form-input>
                            </template>
                            <template #cell(description)="row">
                                <b-form-input :id="row.index + 'description'"
                                    v-model="row.item.description"></b-form-input>
                            </template>
                            <template #cell(is_officer)="row" v-if="!customer_id">
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <input type="checkbox" v-model="row.item.is_officer" disabled
                                            :name="row.index + '-is_officer'" :value="1" :unchecked-value="0" />
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </template>
                            <template #cell(id)="row">
                                <div class="d-flex gap-2">
                                    <b-button :id="row.index + '-save-btn'"  variant="blue-icon" @click="saveSection(row.item)">
                                        <img src="@/assets/images/icon/save.svg" />
                                    </b-button>
                                    <b-button :id="row.index + '-delete-btn'" @click="deleteSection(row.item.id)" class="mr-2" variant="blue-icon">
                                        <img src="@/assets/images/icon/delete.svg" />
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card-body>
    </b-card>
</template>

<script lang="js">
import { debounce } from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import LocationPicker from '@/components/Map/LocationPicker'

const noneError = 'NoneError'
const invalidNameError = 'InvalidName'

const dataItems = Object.freeze([{
    field: 'name',
    type: 'text',
    required: true
},
{
    field: 'is_warehouse',
    type: 'check',
    required: false
},
{
    field: 'country_code',
    type: 'select',
    required: true
},
{
    field: 'county',
    type: 'text',
    required: false
},
{
    field: 'address1',
    type: 'text',
    required: true
},
{
    field: 'address2',
    type: 'text',
    required: false
},
{
    field: 'state_name',
    type: 'select',
    required: true
},
{
    field: 'city',
    type: 'text',
    required: true
},
{
    field: 'postal_code',
    type: 'text',
    required: false
},
{
    field: 'zip_code',
    type: 'text',
    required: false
},
{
    field: 'latitude',
    type: 'text',
    readonly: true,
    required: false
},
{
    field: 'longitude',
    type: 'text',
    readonly: true,
    required: false
},
])

const getDefaultFieldValue = (item) => {
    switch (item.field) {
        case 'country_code':
            return 'JM'
        default:
            return item.type == 'check' ? false : null
    }
}



const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            _form[item.field] = getDefaultFieldValue(item);
            return _form
        }, {
        id: 0
    })
}

const L = window.L
const default_coords = {
    latitude: 18.002804952844535,
    longitude: -76.78970255393327,
}
/////default

export default {
    name: 'locations-view',
    components: {
        LocationPicker
    },
    data() {
        return {
            tabIdx: 0,
            updatedDataItems: [],
            model: generateEmptyForm(),
            internalLoading: false,
            hasErrors: false,
            sectionModel: {
                name: null,
                description: null
            },
        }
    },
    props: {
        id: {
            type: Number,
            default: 0
        },
        sectionOnly: {
            type: Boolean,
            default: false
        },

        hideControls: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },
        customer_id: {
            type: [Number, String],
            default: null
        },
    },
    mixins: [popupMixins, permissionsMixins],

  
    computed: {
        componentName() {
            return this.$translate("location");
        },

        sectionFields() {
            const _fields = [
                { key: "name", label: this.$translate("name") },
                { key: "description", label: this.$translate("description") },

                {
                    key: 'id',
                    label: "",
                },
            ]
            if (!this.customer_id) {
                _fields.splice(2, 0, { key: "is_officer", label: this.$translate("is_officer") })
            }
            return _fields;
        },
        isReadOnly() {
            return !!(this.sectionOnly && this.model.id)
        },
        viewable() {
            return !!this.model.id
        },
        dataItems() {
            const { customer_id } = this;
            return [...dataItems].filter(
                x => (x.field != 'is_warehouse' || !customer_id) &&
                    !(
                        (x.field === 'name' || x.field === 'is_warehouse') &&
                        this.sectionOnly
                    )
            )
        },
        title() {
            return this.model.id ? 'Edit Location' : 'Add Location'
        },
        locationRoute() {
            return this.$route.name.slice(0, 8) === 'location'
        },
        sections() {
            return this.$store.getters['locations/sections']
        },

        simpleLocation() {
            return this.$store.getters['locations/simpleLocation']
        },
        mapLocation() {
            const _location = {
                ...(this.model || {})
            }
            let {
                latitude,
                longitude
            } = _location
            latitude = isNaN(parseFloat(latitude)) ? default_coords.latitude : parseFloat(latitude)
            longitude = isNaN(parseFloat(longitude)) ? default_coords.longitude : parseFloat(longitude)
            try {
                if (
                    !(
                        latitude > -90 &&
                        latitude < 90 &&
                        longitude > -180 &&
                        longitude < 180
                    )
                ) {
                    throw new Error('Invalid Coordinates')
                }
            } catch (error) {
                console.error('mapLocation', error)
                ////////
                latitude = default_coords.latitude
                longitude = default_coords.longitude
            }

            const center = new L.latLng(latitude, longitude)
            this.$set(_location, 'lat', latitude)
            this.$set(_location, 'lng', longitude)
            this.$set(_location, 'center', center)
            return _location
        },

        submitLabel() {
            if (this.internalLoading && this.model.id) {
                return 'Updating...'
            } else if (this.internalLoading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        createLabel() {
            if (this.internalLoading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.internalLoading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        compositeAddress() {
            const { address1, address2, postal_code, state_name, zip_code, city, country_code } = this.model;
            return (address1 ?? '') + (address2 ?? '') + (postal_code ?? '') + (state_name ?? '') + (zip_code ?? '') + (city ?? '') + (country_code ?? '')
        },

        modelStr() {
            return JSON.stringify(this.model)
        },
    },
    watch: {
        simpleLocation: {
            immediate: true,
            handler: function (_location) {
                this.model = {
                    ..._location
                }
            },
            deep: true,
        },

        modelStr: debounce(function (val) {
            this.$emit('update-location-model', JSON.parse(val))
        }, 500),


        compositeAddress: debounce(function (current, previous) {
            current && previous && this.fetchCoordinates()
        }, 500),


        'model.country_code': {
           
            immediate: true,
            handler: async function (val) {
                await this.$store.dispatch('locations/fetchstate', val)
            },
        },

        id: {
            immediate: true,
            handler: function (current) {
                if(current <= 0) return;
                this.setLocation(current)
            }
        },
    },

    async mounted() {
        console.log('this is called');
      
        this.$store.commit('locations/SET_LOCATION', {})
        await this.$store.dispatch('locations/fetchCountry')
        if(this.model.country_code == undefined || this.model.country_code == ""){
            console.log('this is called in');
            this.model.country_code = this.$store.state.company.settings.country_code;
            this.model['country_code'] = this.$store.state.company.settings.country_code;
            console.log('this is called in', this.model.country_code);
        }
       
    },
    beforeDestroy() {
        this.$store.commit('locations/SET_LOCATION', {})
    },
    created() {
        
       
    },

    methods: {
        async setLocation(id) {
        
            try {
                const _locationData = {};
                await this.$store.dispatch('locations/fetchById', id)
                await this.$nextTick()
                if (!this.id) {
                    this.$store.commit('locations/SET_LOCATION', {})
                }
                await this.$nextTick();
                Object.assign(_locationData, this.simpleLocation || {})
                for (const x of dataItems) {
                    const value = _locationData[x.field];
                    this.$set(this.model, x.field, value ?? getDefaultFieldValue(x))
                }
                console.log("setLocation-", this.model)
            } catch (error) {
                console.error("setLocation:", error)
                this.isError = true
            }
        },
        setCoordinates(coords) {
            const {
                lat: latitude,
                lng: longitude
            } = coords
            if (!this.isReadOnly) {
                this.$set(this.model, 'latitude', latitude)
                this.$set(this.model, 'longitude', longitude)
            }
        },

        getLocation(locationData) {
            const country_code = locationData.data.results[0].components.country_code.toUpperCase()
            this.$set(this.model, 'city', locationData.data.results[0].components.city)
            this.$set(this.model, 'state_name', locationData.data.results[0].components.state)
            this.$set(this.model, 'county', locationData.data.results[0].components.county)
            this.$set(this.model, 'country_code', country_code)
            this.$set(this.model, 'address1', (locationData.data.results[0].components.suburb) ? locationData.data.results[0].components.suburb : locationData.data.results[0].components.suburb)
            if (country_code === "US" || country_code === "PH") {
                this.$set(this.model, 'zip_code', locationData.data.results[0].components.postcode)
            } else {
                this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)
            }
        },

        async fetchCoordinates() {
            if (this.isReadOnly) return

            try {
                const {
                    country_code,
                    city,
                    address1, state_name
                } = this.model


                if (!(country_code || city || address1 || state_name))
                    throw new Error('Invalid Address!')

                const coords = await this.$store.dispatch(
                    'locations/geocodeAddress',
                    this.model
                )

                this.$set(this.model, "latitude", coords["latitude"])
                this.$set(this.model, "longitude", coords["longitude"])
            } catch (err) {
                //console.log('fetchCoordinates error', err)
            }
        },

        capitalCase(data) {
            if (data == 'country_code') return 'Country/Region'
            if (data == 'postal_code') return 'Post Office/District Code'
            if (data == 'state_name') return 'State/Province/Region/Parish'
            const list = data.split('_')
            if (list[list.length - 1] === 'id') {
                list.pop()
            }
            return list
                .map(
                    x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase()
                )
                .join('  ')
        },
        getData(field) {
            return (() => {
                switch (field) {
                    case 'country_code':
                        return this.$store.state.locations.country
                    case 'state_name':
                        return this.$store.state.locations.states
                }
            })()
        },

        async deleteLocation() {
            try {
                const { id } = this.model;
                const result = await this.confirmMessage(
                    `${this.$translate('delete_location')}?`,
                    `${this.$translate('delete_note')} ${this.componentName}?`
                )

                if (!result) {
                    throw noneError
                }
                this.internalLoading = true
                await this.$store.dispatch('locations/delete', id)

                this.genericToast(this.componentName, this.$translate('deleted'), 'success', `${this.componentName} ${this.$translate('delete_alert')} `)

            } catch (error) {
                console.error(error)
                if (error != noneError) {
                    this.doToast(
                        this.$translate('error'),
                        this.$translate('unable_to_delete_location'),
                        'danger'
                    )
                }
            } finally {
                this.internalLoading = false
                if (!this.customer_id) {
                    this.$router.go(-1)
                }
            }
        },

        async deleteSection(id) {
            try {
                const location_id = this.simpleLocation.id
                const result = await this.confirmMessage(
                    `${this.$translate('delete_location')} ${this.$translate('section')}?`,
                    `${this.$translate('delete_note')} ${this.$translate('location_section')}?`
                )

                if (!result) {
                    throw noneError
                }
                this.internalLoading = true
                await this.$store.dispatch('locations/deleteSection', {
                    id,
                    location_id,
                })

                this.genericToast(this.componentName, this.$translate('deleted'), 'success', `${this.$translate('location_section')} ${this.$translate('delete_alert')}`)

            } catch (error) {
                console.log('error message', error)
                if (error != noneError) {
                    const message =
                        this.$translate('delete_section')
                    this.doToast(this.$translate('error'), message, 'danger')
                }
            } finally {
                this.internalLoading = false
            }
        },

        async onSubmit() {
            try {
                this.internalLoading = true;
                const model = { ...this.model };
                if (!model.latitude || !model.longitude) {
                    this.doToast(
                        this.$translate('error'),
                        this.$translate("lat_long_missing_alert"),
                        'danger'
                    );
                    return;
                }

                if (this.sectionOnly && !model.id) {
                    model.name = model.name || Date.now().toString(36);
                    model.is_warehouse = false;
                }

                if (this.customer_id) {
                    model.is_warehouse = false;
                    model.customer_id = this.customer_id;
                } else {
                    model.is_warehouse = !!model.is_warehouse;
                    model.customer_id = null;
                }

                // Set internalLoading to true before validation
                this.internalLoading = true;
                const valid = await this.$validator.validate();
                // Set internalLoading back to false after validation
                this.internalLoading = false;

                if (!valid) {
                    this.doToast(this.$translate('error'), this.$translate('invalid'), 'danger');
                    return;
                }

                if (valid) {
                    // Set internalLoading to true before emitting the save-location event
                    this.internalLoading = true;

                    const id = model.id
                    delete model.id
                    const payload = { ...model };
                    const path = id ? 'locations/update' : 'locations/create'
                    const action = id ? this.$translate('updated') : this.$translate('created')
                    const type = 'success'


                    await this.$store.dispatch(path, { id, payload })

                    this.genericToast(
                        this.componentName,
                        action,
                        type,
                        id ?
                            `${this.componentName} ${this.$translate('update_alert')}` :
                            `${this.componentName} ${this.$translate('create_alert')}`
                    )
                    //this.doToast('Success!', title, type)
                    if (!this.customer_id) {
                        this.$router.go(-1)
                    }
                }
            } catch (error) {
                console.error('An error occurred:', error);
                // Ensure that internalLoading is set back to false in case of an error
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.internalLoading = false;
            }
        },

        // fetchState(item, event) {
        //     this.model.state = null;
        //     const country_code = event
        //     this.$store.commit('locations/SET_STATES', null);
        //     this.$store.dispatch('locations/fetchstate', { country_code })
        // },



        /**
                * Stores the section data
                */
        async saveSection({ id, name, description, is_officer }) {
            try {
                const {
                    id: location_id
                } = this.simpleLocation
                this.internalLoading = true


                // Check if the Section is empty
                if (!/^[a-z][a-z\d\-_\s]+$/i.test(name)) {
                    throw invalidNameError
                }
                // const { id: location_id } = this.item
                const payload = { name, is_officer, description }
                const path = id
                    ? 'locations/updateSection'
                    : 'locations/createSection'

                await this.$store.dispatch(path, {
                    location_id,
                    id,
                    payload,
                })

                if (!id) {
                    this.$set(this.sectionModel, "name", null);
                    this.$set(this.sectionModel, "description", null);
                }

                this.genericToast(this.componentName, this.$translate('created'), 'success', `${this.componentName} ${this.$translate('section')} ${this.$translate('create_alert')}`)
            } catch (error) {
                console.error('saveSection', (error && error.message) || error)
                if (error === invalidNameError) {
                    this.doToast(
                        `${this.$translate('error')}`,
                        this.$translate('invalid_section_name'),
                        'danger'
                    )
                } else {
                    this.doToast(`${this.$translate('error')}`, this.$translate('unable_section'), 'danger')
                }
            } finally {
                this.internalLoading = false
                this.$forceUpdate()
            }
        }
      
    },
}
</script>
<style></style>
